import React from 'react';
import PropTypes from 'prop-types';
import Loader from '../Loader/Loader';

const Button = (props) => {
    const { text, className, onClick, disabled, isLoading, id } = props;
    return (
        <button
            id={id}
            type="button"
            className={className}
            onClick={onClick}
            disabled={disabled} >
            {text}
            {isLoading ? <Loader className="btn-load"/> : null}
        </button>
    );
}

Button.propTypes = {
    text: PropTypes.string.isRequired,
    className: PropTypes.string,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    isLoading: PropTypes.bool,
    string: PropTypes.string,
}

export default Button;



// WEBPACK FOOTER //
// ./src/components/common/Button/Button.js